module.exports = __webpack_public_path__ + "static/ffae8ee9.oldUI_out_modal.png";